export default "__VITE_ASSET__f10f724a__"